"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logos = void 0;
var hopin_app_store_1 = require("./hopin-app-store");
var hopin_default_1 = require("./hopin-default");
var hopin_explore_1 = require("./hopin-explore");
var hopin_inverse_1 = require("./hopin-inverse");
var hopin_pictorial_1 = require("./hopin-pictorial");
var hopin_two_tone_1 = require("./hopin-two-tone");
var ringcentral_default_1 = require("./ringcentral-default");
var ringcentral_inverse_1 = require("./ringcentral-inverse");
var session_default_1 = require("./session-default");
var session_pictorial_1 = require("./session-pictorial");
var streamyard_default_1 = require("./streamyard-default");
var streamyard_pictorial_1 = require("./streamyard-pictorial");
// All keys are wrapped in quotes for easier programmatic sorting
// prettier-ignore
exports.logos = {
    'hopin-default': hopin_default_1.HopinDefaultLogo,
    'hopin-two-tone': hopin_two_tone_1.HopinTwoToneLogo,
    'hopin-inverse': hopin_inverse_1.HopinInverseLogo,
    'hopin-pictorial': hopin_pictorial_1.HopinPictorialLogo,
    'hopin-explore': hopin_explore_1.HopinExploreLogo,
    'hopin-app-store': hopin_app_store_1.HopinAppStoreLogo,
    'ringcentral-default': ringcentral_default_1.RingCentralDefaultLogo,
    'ringcentral-inverse': ringcentral_inverse_1.RingCentralInverseLogo,
    'session-default': session_default_1.SessionDefaultLogo,
    'session-pictorial': session_pictorial_1.SessionPictorialLogo,
    'streamyard-default': streamyard_default_1.StreamyardDefaultLogo,
    'streamyard-pictorial': streamyard_pictorial_1.StreamyardPictorialLogo,
};
//# sourceMappingURL=index.js.map